<!-- Head -->
<ng-template #dialogHead>
  <div style="display: flex; flex-direction: column; align-items: center;">
    <h2>Sync Active Plans</h2>
    <label class="label-subtitle">Select which plan details you want to sync over to your active plans.</label>
  </div>


  <button mat-icon-button (click)="onClose()" class="custom-mat-icon-button button-close-panel">
    <mat-icon svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
  </button>
</ng-template>
<!-- Body -->
<ng-template #dialogBody>
  <mat-tab-group mat-align-tabs="center" class="custom-mat-tab-group" dynamicHeight>
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Details</span>
      </ng-template>
      <div>
        <div *ngFor="let details of listOfDetails; let i = index" style="margin-bottom: 10px;">
          <mat-checkbox disableRipple="true" class="custom-mat-checkbox rounded checkbox--with--description" color="primary" [(ngModel)]="details.value" [ngModelOptions]="{standalone: true}">
            <span class="typo semi-condensed fw400">{{ details.label }}</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Price</span>
      </ng-template>
      <div>
        <div *ngFor="let details of listOfPricing; let i = index" style="margin-bottom: 10px;">
          <mat-checkbox disableRipple="true" class="custom-mat-checkbox rounded checkbox--with--description" color="primary" [(ngModel)]="details.value" [ngModelOptions]="{standalone: true}">
            <span class="typo semi-condensed fw400">{{ details.label }}</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Schedule</span>
      </ng-template>
      <div>
        <div *ngFor="let details of listOfSchedule; let i = index" style="margin-bottom: 10px;">
          <mat-checkbox disableRipple="true" class="custom-mat-checkbox rounded checkbox--with--description" color="primary" [(ngModel)]="details.value" [ngModelOptions]="{standalone: true}">
            <span class="typo semi-condensed fw400">{{ details.label }}</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Rules</span>
      </ng-template>
      <div>
        <div *ngFor="let details of listOfRules; let i = index" style="margin-bottom: 10px;">
          <mat-checkbox disableRipple="true" class="custom-mat-checkbox rounded checkbox--with--description" color="primary" [(ngModel)]="details.value" [ngModelOptions]="{standalone: true}">
            <span class="typo semi-condensed fw400">{{ details.label }}</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-template>
<!-- Nav -->
<ng-template #dialogNav>
  <button mat-flat-button (click)="onSubmit()" color="primary" class="mat-button custom-mat-button-primary">Save changes</button>
</ng-template>

<app-dialog
  [dialogHead]="dialogHead"
  [dialogBody]="dialogBody"
  [dialogNav]="dialogNav">
</app-dialog>
